// @flow
import React, { Fragment } from 'react';
import PartnerCard from 'components/common/PartnerCard';
import type { PartnerItem } from 'store/modules/partnering';
import FakePartnerCard from 'components/common/FakePartnerCard';
import './PartnerCardList.scss';

type Props = {
  partners?: ?(PartnerItem[]),
  loading: boolean,
  prefetching: boolean,
  width?: number,
  hasEnded: boolean,
  oneColumn?: boolean,
  placeholderCount?: number,
  hideUsername?: boolean,
  isTrending?: boolean,
};

const createArray = length => Array.from(Array(length).keys());
const getColumnCount = width => {
  const xWide = 1920;
  const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 1;

  if (width < medium) return 4;
  if (width < large) return 6;
  if (width < xLarge) return 6;
  if (width < wide) return 6;
  if (width < xWide) return 12;
  return 12;
};

const getTrendingCount = width => {
  // const xWide = 1920;
  // const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 4;

  if (width < medium) return 4;
  if (width <= large) return 6;
  if (width <= xLarge) return 8;
  // if (width <= wide) return 8;
  // if (width <= xWide) return 10;
  return 10;
};

const PartnerCardList = ({
  partners,
  loading,
  prefetching,
  width,
  hasEnded,
  oneColumn,
  hideUsername,
  isTrending,
}: Props) => {
  const trendingCount = getTrendingCount(width);
  if (loading) {
    return (
      <div className="PartnerCardList">
        {createArray(trendingCount).map(num => (
          <FakePartnerCard key={num} oneColumn={oneColumn} />
        ))}
      </div>
    );
  }

  const columnCount = oneColumn ? 1 : getColumnCount(width);
  if (!partners) return null;
  const TrendingList = isTrending ? partners.slice(0, trendingCount) : partners;
  const partnerList = (hasEnded || partners.length <= 10
    ? TrendingList
    : partners.slice(0, partners.length - (partners.length % columnCount))
  ).map(partner => (
    <PartnerCard
      key={partner.id}
      id={partner.id}
      thumbnail={partner.thumbnail}
      title={partner.title}
      body={partner.meta && partner.meta.short_description}
      partnerUrl={partner.meta && partner.meta.partnerUrl}
      urlSlug={partner.url_slug}
      oneColumn={oneColumn}
    />
  ));

  return (
    <Fragment>
      <div className="PartnerCardList">
        {partnerList && partnerList.length === 0 && (
          <div className="empty-list">아직 등록된 파트너가 없습니다.</div>
        )}
        {partnerList}
        {prefetching &&
          createArray(columnCount).map(num => <FakePartnerCard key={num} oneColumn={oneColumn} />)}
      </div>
    </Fragment>
  );
};

PartnerCardList.defaultProps = {
  partners: [],
  oneColumn: false,
  width: 0,
  placeholderCount: 12,
  hideUsername: false,
};

export default PartnerCardList;



// WEBPACK FOOTER //
// ./src/components/common/PartnerCardList/PartnerCardList.js